var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.16663C17.5 7.1775 16.7098 5.26985 15.3033 3.86333C13.8968 2.4568 11.9891 1.66663 10 1.66663C8.01088 1.66663 6.10322 2.4568 4.6967 3.86333C3.29018 5.26985 2.5 7.1775 2.5 9.16663C2.5 12.4333 4.59167 15.2 7.5 16.2333V18.3333H9.16667V16.6166C9.72019 16.6838 10.2798 16.6838 10.8333 16.6166V18.3333H12.5V16.2333C15.4083 15.2 17.5 12.4333 17.5 9.16663ZM10 15C6.78333 15 4.16667 12.3833 4.16667 9.16663C4.16667 5.94996 6.78333 3.33329 10 3.33329C13.2167 3.33329 15.8333 5.94996 15.8333 9.16663C15.8333 12.3833 13.2167 15 10 15Z",
    fill: "#2B8D3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 5.83337H13.3333V7.50004H6.66667V5.83337ZM10.625 8.33337L8.12501 10.8334L9.16667 11.875L8.12501 12.9167L9.37501 14.1667L11.875 11.6667L10.8333 10.625L11.875 9.58337L10.625 8.33337Z",
    fill: "#2B8D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.c5f3e4de5b087fd559ea247b7990656e.svg";
export { ForwardRef as ReactComponent };